var map = {
	"./adapay-gif.gif": 266,
	"./adapay-logo.svg": 157,
	"./adapay.svg": 158,
	"./adapayBusinessCoti-dark.svg": 215,
	"./adapayBusinessCoti.svg": 216,
	"./cardano-bg-element-mobile.png": 447,
	"./cardano-bg-element.png": 448,
	"./close-modal-icon.svg": 159,
	"./close.svg": 160,
	"./completed.svg": 217,
	"./copy-icon.png": 449,
	"./copy.svg": 218,
	"./coti-logo.png": 204,
	"./coti_pay_black.png": 450,
	"./dashboard/ada.svg": 161,
	"./dashboard/btc.svg": 162,
	"./dashboard/daily.svg": 163,
	"./dashboard/monthly.svg": 164,
	"./dashboard/usd.svg": 165,
	"./dropdown-chevron.svg": 166,
	"./fail.svg": 219,
	"./image2.png": 451,
	"./inner-title/ada.svg": 102,
	"./inner-title/btc.svg": 103,
	"./inner-title/integration-tools.svg": 104,
	"./inner-title/invoice.svg": 63,
	"./inner-title/new-withdrawal.svg": 105,
	"./inner-title/recent.svg": 106,
	"./inner-title/revenue.svg": 107,
	"./inner-title/settings-large.svg": 108,
	"./inner-title/settlement.svg": 109,
	"./inner-title/timeline.svg": 110,
	"./inner-title/total.svg": 111,
	"./inner-title/usd.svg": 112,
	"./inner-title/withdrawals.svg": 113,
	"./link-icon.svg": 167,
	"./logo-dark.svg": 220,
	"./logo.svg": 221,
	"./logoBG-mobile.svg": 222,
	"./logoBG.svg": 223,
	"./logout.svg": 224,
	"./lp/approved.png": 267,
	"./lp/done.svg": 168,
	"./lp/online.png": 268,
	"./lp/payment.png": 269,
	"./lp/purchasing.png": 270,
	"./lp/transaction.png": 271,
	"./lp/triangle.svg": 169,
	"./menu/dashboard-color.svg": 127,
	"./menu/dashboard.svg": 170,
	"./menu/logoutmobile.svg": 128,
	"./menu/menu-b.png": 272,
	"./menu/menu.png": 273,
	"./menu/overview-color.svg": 129,
	"./menu/overview.svg": 171,
	"./menu/payments-color.svg": 130,
	"./menu/payments.svg": 172,
	"./menu/settings-color.svg": 131,
	"./menu/settings.svg": 173,
	"./menu/settlement-color.svg": 132,
	"./menu/settlement.svg": 174,
	"./menu/tools-color.svg": 133,
	"./menu/tools.svg": 175,
	"./menu/withdrawals-color.svg": 134,
	"./menu/withdrawals.svg": 176,
	"./notification.svg": 225,
	"./payment-info-icon.svg": 177,
	"./payments/backdesktop.svg": 43,
	"./payments/completed.svg": 114,
	"./payments/confirmed.svg": 115,
	"./payments/dropdown.svg": 64,
	"./payments/expired-2.svg": 116,
	"./payments/expired.svg": 117,
	"./payments/failed.svg": 118,
	"./payments/left-arrow-first-hover.svg": 69,
	"./payments/left-arrow-first.svg": 70,
	"./payments/left-arrow-hover.svg": 71,
	"./payments/left-arrow.svg": 72,
	"./payments/new.svg": 119,
	"./payments/nothing-found-grey.svg": 85,
	"./payments/overpaid.svg": 120,
	"./payments/paid.svg": 121,
	"./payments/payment-sent.svg": 122,
	"./payments/pending.svg": 123,
	"./payments/refund.svg": 124,
	"./payments/right-arrow-hover.svg": 73,
	"./payments/right-arrow-last-hover.svg": 74,
	"./payments/right-arrow-last.svg": 75,
	"./payments/right-arrow.svg": 76,
	"./payments/search.svg": 125,
	"./payments/searchperiod.svg": 86,
	"./payments/underpaid.svg": 126,
	"./save-the-children.svg": 226,
	"./settlement/bank-white.svg": 227,
	"./settlement/bank.svg": 228,
	"./settlement/wallet-white.svg": 229,
	"./settlement/wallet.svg": 230,
	"./shield.svg": 231,
	"./signup/account.svg": 135,
	"./signup/company.svg": 178,
	"./signup/login.svg": 136,
	"./signup/pass-hide-hover.svg": 95,
	"./signup/pass-hide.svg": 93,
	"./signup/pass-show-hover.svg": 94,
	"./signup/pass-show.svg": 92,
	"./signup/pass.svg": 137,
	"./signup/resetpass.svg": 179,
	"./statuses/confirmemail.svg": 180,
	"./statuses/emailthankyou.svg": 181,
	"./statuses/thankyou.svg": 182,
	"./sync.svg": 232,
	"./timeline/completed-dark-blue-2.svg": 233,
	"./timeline/expired-2.svg": 234,
	"./timeline/failed-2.svg": 235,
	"./timeline/new-2.svg": 236,
	"./timeline/paid-dark-blue-2.svg": 237,
	"./timeline/timeline-approved.svg": 238,
	"./timeline/timeline-awaiting-approval.svg": 239,
	"./timeline/timeline-cancelled.svg": 240,
	"./timeline/timeline-processing.svg": 241,
	"./tools/button-paywithcoti.svg": 242,
	"./tools/completed.svg": 243,
	"./tools/pay-with-ada.svg": 183,
	"./transaction/confirmed.svg": 184,
	"./transaction/expired.svg": 185,
	"./transaction/pending.svg": 186,
	"./trash.svg": 244,
	"./wallet.svg": 245,
	"./warning.svg": 246,
	"./withdrawals/accepted.svg": 187,
	"./withdrawals/confirmed.svg": 188,
	"./withdrawals/fully_processed.svg": 189,
	"./withdrawals/new.svg": 190,
	"./withdrawals/notification.svg": 191,
	"./withdrawals/pending.svg": 192,
	"./withdrawals/rejected.svg": 193,
	"./withdrawals/tl-approved.svg": 194,
	"./withdrawals/tl-awaiting-approval.svg": 195,
	"./withdrawals/tl-processing.svg": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;